import {
  COORDINATOR_ROLE,
  CUSTOMER_MEMBER_ROLE,
  FAMILY_ROLE,
  ORGANISATION_ADMIN_ROLE,
} from '@careapp-group/core';
import { EnquiryDto } from '@careapp-group/ng-sdk';
import { createSelector } from '@ngrx/store';
import { caCreateEntitySelectors } from '../../store/entity-state/entity-selectors';
import { EnquiriesState, EnquiriesFilterType } from './enquiries.reducer';
import {
  hasEnquiriesFeature,
  getUserOrganisationRoles,
} from '../../store/organisations/organisations.selectors';
import { getEnquiriesState } from '../../store/reducers';

export const EnquiriesSelectors = caCreateEntitySelectors<EnquiryDto, EnquiriesState>('enquiries');

export const getFilterForSegment = (segment: string) =>
  createSelector(EnquiriesSelectors.getPaginators, (paginators): EnquiriesFilterType => {
    return paginators && paginators[segment] ? paginators[segment].filter || {} : {};
  });

export const getEnquiriesOrgInsightsFilter = getFilterForSegment('orgInsights');

export const enquiriesUnreadCount = createSelector(
  getEnquiriesState,
  (enquiriesState) => enquiriesState?.unreadCount ?? 0,
);

export const userHasEnquiries = createSelector(
  hasEnquiriesFeature,
  getUserOrganisationRoles,
  (hasEnquiries: boolean, orgRoles: string[]) => {
    if (!hasEnquiries) {
      return false;
    }

    const allowedRoles = [
      ORGANISATION_ADMIN_ROLE,
      COORDINATOR_ROLE,
      FAMILY_ROLE,
      CUSTOMER_MEMBER_ROLE,
    ];
    return orgRoles ? orgRoles.some((role) => allowedRoles.includes(role)) : false;
  },
);

export const userCanManageEnquiries = createSelector(
  userHasEnquiries,
  getUserOrganisationRoles,
  (hasEnquiries: boolean, orgRoles: string[]) => {
    const allowedRoles = [ORGANISATION_ADMIN_ROLE, COORDINATOR_ROLE];
    return hasEnquiries && orgRoles ? orgRoles.some((role) => allowedRoles.includes(role)) : false;
  },
);

// :Note: (TB, 30 Oct '25) While we do have selectedId on hand to use,
// the format of CID is different to the ID we use to store an enquiry entity.
export const getActiveEnquiryChannelCid = createSelector(
  getEnquiriesState,
  (enquiriesState) => enquiriesState?.activeChannelCid ?? null,
);
